// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"42174be4","392":"91a3eb3c","455":"b424fddf","577":"33bacfa8","977":"15b58283"}[chunkId] + ".chunk.js";
};